var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRealtimeSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77011 19.33H19.4321C20.1277 19.2314 20.7596 18.8719 21.1998 18.3244C21.6399 17.7769 21.8553 17.0825 21.8021 16.382C21.8419 15.6657 21.6252 14.9586 21.1909 14.3876C20.7566 13.8166 20.133 13.4189 19.4321 13.266C19.4032 12.674 19.2518 12.0945 18.9876 11.564C18.7234 11.0334 18.3521 10.5634 17.8971 10.1836C17.4422 9.80379 16.9134 9.52242 16.3442 9.35726C15.775 9.1921 15.1777 9.14672 14.5901 9.224C13.9394 9.23159 13.2968 9.36924 12.7001 9.62885C12.1034 9.88846 11.5646 10.2648 11.1155 10.7357C10.6664 11.2066 10.316 11.7626 10.085 12.3709C9.85392 12.9793 9.74686 13.6277 9.77011 14.278C9.12121 14.3096 8.50934 14.5897 8.06127 15.0601C7.6132 15.5306 7.36328 16.1553 7.36328 16.805C7.36328 17.4547 7.6132 18.0795 8.06127 18.5499C8.50934 19.0203 9.12121 19.2984 9.77011 19.33Z",
    fill: "#2C4C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29591 17.344C0.800895 14.5365 1.20735 11.6443 2.45703 9.08204C3.70671 6.51973 5.73545 4.41879 8.25252 3.08032C10.7696 1.74185 13.6458 1.23456 16.4689 1.63114C19.292 2.02773 21.917 3.30784 23.9679 5.288",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0577 2.006L24.6797 6.322L20.3657 5.944",
    stroke: "#2C4C8F",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8841 12.654C28.3798 15.4628 27.9732 18.3565 26.7225 20.9198C25.4718 23.4832 23.4413 25.5846 20.9224 26.9226C18.4035 28.2606 15.5255 28.7664 12.7014 28.3674C9.87718 27.9685 7.25191 26.6853 5.20215 24.702",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12207 27.994L4.50007 23.678L8.82207 24.056",
    stroke: "#2C4C8F",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRealtimeSync);
export default __webpack_public_path__ + "static/media/ic_realtime_sync.108f02d2bea00338e44f39139814cbca.svg";
export { ForwardRef as ReactComponent };